/* eslint no-var: 0 */
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { languages } from '../locale'
import { app } from '../app'

interface IReadSpeaker {
  ui: {
    addClickEvents: () => void
    getActivePlayer: () => { show: () => void; close: () => void }
  }
  p: (cb: (...args: any) => any) => void
  q: (cb: (...args: any) => any) => void
  init: () => void
}

declare var ReadSpeaker: IReadSpeaker

function TextReader() {
  const [showTextReader, setShowTextReader] = useState(false);
  const [url, setUrl] = useState('');
  const [lang, setLang] = useState('');
  const currentLocale = languages[app.locale]?.zendesk as string ?? app.locale;

  useEffect(() => {
    // Initialize ReadSpeaker if it is available
    if (typeof ReadSpeaker !== 'undefined') {
      ReadSpeaker.p(() => {
        ReadSpeaker.init();
        ReadSpeaker.q(() => {
          ReadSpeaker.ui.addClickEvents();
        });
      });
    }

    const setLanguage = () => {
      const langMap: { [key: string]: string } = {
        ar: 'ar_ar',
        cs: 'cs_cz',
        'en-us': 'en_us',
        es: 'es_mx',
        fa: 'fa_ir',
        fr: 'fr_be',
        hu: 'hu_hu',
        pl: 'pl_pl',
        ru: 'ru_ru',
        uk: 'uk_ua',
      };

      const selectedLang = langMap[currentLocale.toLowerCase()] || '';
      setLang(selectedLang);
      setShowTextReader(!!selectedLang);
    };

    setLanguage();
    setUrl(encodeURIComponent(window.location.href));
  }, [currentLocale]);

  useEffect(() => {
    // Cleanup function to close the ReadSpeaker player if it is open.
    //
    // ReadSpeaker is a global from a CDN <script> in each package's index.html,
    // so it is absent when that script is not included or has not loaded (it is
    // async). Referencing the bare identifier then throws a ReferenceError from
    // an unmount effect, which React escalates into unmounting the whole tree.
    return () => {
      const rs = (window as any).ReadSpeaker;
      if (rs?.ui?.getActivePlayer?.()) {
        rs.ui.getActivePlayer().close();
      }
    };
  }, []);

  return (
    <div className="min-w-[370px]">
      {showTextReader && (
        <div
          id="readspeaker_button1"
          className="rs_skip rsbtn rs_preserve !m-0"
        >
          <a
            rel="nofollow"
            className="rsbtn_play readspeaker"
            title="ReadSpeaker webReader إستمع إلى هذه الصفحةِ مستخدماً"
            href={`https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=11950&lang=${lang}&readid=main-content&url=${url}`}
          >
            <span className="rsbtn_left rsimg rspart">
              <span className="rsbtn_text">
                <span className='text-left box-border m-0 p-0 border-0 align-baseline outline-none font-bold h-full pl-8' >Listen</span>
              </span>
            </span>
            <span className="rsbtn_right rsimg rsplay rspart"></span>
          </a>
        </div>
      )}
    </div >
  )
}

export default TextReader
